export enum Limitations {
  userGuideMinTitle = 2,
  userGuideMaxTitle = 2 ** 6,
  userGuideMinDescription = 2 ** 4,
  userGuideMaxDescription = 2 ** 8,

  faqsMinQuestion = 2,
  faqsMaxQuestion = 2 ** 7,
  faqsMinAnswer = 2,
  faqsMaxAnswer = 2 ** 8,

  categoriesMinTitle = 2,
  categoriesMaxTitle = 2 ** 6,

  courtMinTitleLength = 2,
  courtMaxTitleLength = 2 ** 5,
  courtMinDescriptionLength = 20,
  courtMaxDescriptionLength = 2 ** 8,

  aboutMinLength = 2 ** 5,
  aboutMaxLength = 2 ** 12,

  contactUsMinLength = 2 ** 5,
  contactUsMaxLength = 2 ** 12,

  termsMinLength = 2 ** 5,
  termsMaxLength = 2 ** 12,

  sportsClubsAddressMinLength = 20,
  sportsClubsAddressMaxLength = 2 ** 8,
  sportsClubsMinNameLength = 2,
  sportsClubsMaxNameLength = 50,
  sportsClubsMinDescriptionLength = 20,
  sportsClubsMaxDescriptionLength = 2 ** 8,

  BrandsMinNameLength = 2,
  BrandsMaxNameLength = 50,

  ProductsMinTitleLength = 2,
  ProductsMaxTitleLength = 2 ** 5,
  ProductsMinDescriptionLength = 20,
  ProductsMaxDescriptionLength = 2 ** 8,

  placesMinNameLength = 3,
  placesMaxNameLength = 32,
  placesMinDetailsLength = 20,
  placesMaxDetailsLength = 2 ** 8,
  placesMinDescriptionLength = 20,
  placesMaxDescriptionLength = 2 ** 8,

  AgentsMinNameLength = 2,
  AgentsMaxNameLength = 2 ** 5,
}
